import { createSlice } from "@reduxjs/toolkit"
import { storeOrder } from "../actions/checkoutAction"

const CheckoutReducers = createSlice({
  name: "CheckoutReducers",
  initialState: {
    data: null,
    loader: false,
    errors: null,
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      /**
       * Checkout
       */
      .addCase(storeOrder.pending, (state) => {
          state.loader = true;
          state.errors = null;
      })
      .addCase(storeOrder.fulfilled, (state, action) => {
          state.loader = false;
          state.userDetails = action.payload; 
      })
      .addCase(storeOrder.rejected, (state, action) => {
          state.loader = false;
          state.errors = action.payload;
      });
  },
});


export default CheckoutReducers.reducer;